module.exports = __webpack_public_path__ + "static/Image2-5a44a37d405b0293d3c50c194e2a9646.png";